import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeSearchPopupComponent } from './components/home-search-popup/home-search-popup.component';
import { PopupService } from '@local/ui-infra';
import { ResultsModule } from '../results/results.module';
import { CollectionsPageModule } from '../collections-page/collections-page.module';
import { WebSearchModule } from '../web-search/web-search.module';
import { TelemetryHelperService } from '../../services/telemetry.helper.service';
import { HomeSearchPopupService } from './services/home-search-popup.service';
import { AssistantPageModule } from '../settings/components/assistant-page/assistant-page.module';

@NgModule({
  declarations: [HomeSearchPopupComponent],
  imports: [CollectionsPageModule, ResultsModule, WebSearchModule, AssistantPageModule],
  providers: [HomeSearchPopupService, { provide: PopupService, useClass: PopupService }],
  exports: [HomeSearchPopupComponent],
})
export class HomeSearchPopupModule {}
